import { useMutation, useQueryClient } from "@tanstack/react-query";
import { toast } from "react-toastify";

import { updateSupplementalQuestion } from "~/providers/api";
import { supplementalQuestionsQueryOptionsFactory } from "~/providers/factories/supplementalQuestionsQueryOptionsFactory";

export const useUpdateSupplementalQuestion = () => {
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: updateSupplementalQuestion,
    onError: () =>
      toast.error(
        "There was an issue updating the question. Please try again later.",
      ),
    onSuccess: () => {
      queryClient
        .invalidateQueries({
          queryKey: supplementalQuestionsQueryOptionsFactory.list._def,
          exact: false,
        })
        .catch(() => {
          toast.error("Failed to refresh questions data.");
        });
    },
  });
};
